module.exports = __webpack_public_path__ + "img/point3.e5a4c3a9.jpg";